"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, // database to virtual relation and create an index for it
"default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _globals = require("~/utils/globals");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _models = require("~/models");
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// An upgrader for upgrading LTAR relations in XCDB sources
// it will delete all the foreign keys and create a new index
// and treat all the LTAR as virtual
async function upgradeModelRelations(context, { model, relations, ncMeta, sqlClient }) {
    // Iterate over each column and upgrade LTAR
    for (const column of (await model.getColumns(context, ncMeta))){
        if (column.uidt !== _nocodbsdk.UITypes.LinkToAnotherRecord) {
            continue;
        }
        const colOptions = await column.getColOptions(context, ncMeta);
        // if colOptions not found then skip
        if (!colOptions) {
            continue;
        }
        switch(colOptions.type){
            case _nocodbsdk.RelationTypes.HAS_MANY:
                {
                    // skip if virtual
                    if (colOptions.virtual) {
                        break;
                    }
                    const parentCol = await colOptions.getParentColumn(context, ncMeta);
                    const childCol = await colOptions.getChildColumn(context, ncMeta);
                    const parentModel = await parentCol.getModel(context, ncMeta);
                    const childModel = await childCol.getModel(context, ncMeta);
                    // delete the foreign key constraint if exists
                    const relation = relations.find((r)=>{
                        return parentCol.column_name === r.rcn && childCol.column_name === r.cn && parentModel.table_name === r.rtn && childModel.table_name === r.tn;
                    });
                    // delete the relation
                    if (relation) {
                        await sqlClient.relationDelete({
                            parentColumn: relation.rcn,
                            childColumn: relation.cn,
                            parentTable: relation.rtn,
                            childTable: relation.tn,
                            foreignKeyName: relation.cstn
                        });
                        // skip postgres since we were already creating the index while creating the relation
                        if (ncMeta.knex.clientType() !== 'pg') {
                            // create a new index for the column
                            const indexArgs = {
                                columns: [
                                    relation.cn
                                ],
                                tn: relation.tn,
                                non_unique: true
                            };
                            await sqlClient.indexCreate(indexArgs);
                        }
                    }
                }
                break;
        }
        // update the relation as virtual
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.COL_RELATIONS, {
            virtual: true
        }, colOptions.id);
        // update the cache as well
        const cachedData = await _NocoCache.default.get(context, `${_globals.CacheScope.COL_RELATION}:${colOptions.fk_column_id}`, _globals.CacheGetType.TYPE_OBJECT);
        if (cachedData) {
            cachedData.virtual = true;
            await _NocoCache.default.set(context, `${_globals.CacheScope.COL_RELATION}:${colOptions.fk_column_id}`, cachedData);
        }
    }
}
// An upgrader for upgrading any existing relation in xcdb
async function upgradeBaseRelations(context, { ncMeta, source, relations }) {
    const sqlClient = await _NcConnectionMgrv2.default.getSqlClient(source, ncMeta.knex);
    // get models for the base
    const models = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.MODELS);
    // get all columns and filter out relations and upgrade
    for (const model of models){
        await upgradeModelRelations(context, {
            ncMeta,
            model: new _models.Model(model),
            sqlClient,
            relations
        });
    }
}
async function _default({ ncMeta }) {
    var _data, _this;
    // get all xcdb sources
    const sources = await ncMeta.knexConnection(_globals.MetaTable.SOURCES).where({
        is_meta: 1
    });
    if (!sources.length) return;
    const sqlClient = await _NcConnectionMgrv2.default.getSqlClient(new _models.Source(sources[0]), ncMeta.knex);
    // get all relations
    const relations = (_this = await sqlClient.relationListAll()) == null ? void 0 : (_data = _this.data) == null ? void 0 : _data.list;
    // iterate and upgrade each base
    for (const source of sources){
        const context = {
            workspace_id: source.fk_workspace_id,
            base_id: source.id
        };
        await upgradeBaseRelations(context, {
            ncMeta,
            source: new _models.Source(source),
            relations
        });
    }
}
